import Icon from 'vue-awesome/components/Icon'

Icon.register({
  edit_attributes_sharp: {
    paths: [
      {
        d: 'M17.63 7H6.37C3.96 7 2 9.24 2 12s1.96 5 4.37 5h11.26c2.41 0 4.37-2.24 4.37-5s-1.96-5-4.37-5zM7.24 14.46l-2.57-2.57.7-.7 1.87 1.87 3.52-3.52.7.7-4.22 4.22z'
      }
    ],
    width: '24',
    height: '24'
  }
})
